// Single source of truth for "is this profile complete enough to use the app?"
//
// These are exactly the fields POST /projects/preview requires (the safety /
// kcal review inputs). Before this module existed, three places each held their
// own opinion of "complete": Welcome blocked submit on sex only, BootGate
// checked sex + date_of_birth, and the worker's preview demanded all five.
// A user could therefore finish onboarding without height/weight, sail through
// BootGate, and dead-end at the project wizard's timeline step with a 409
// "Profile incomplete". Welcome and BootGate now both reference this list, so
// "complete" means one thing everywhere and that gap cannot reopen.
import type { User, UserProfile } from '../types';

// Required fields stored on user_profiles. Each is value-or-null; null = not
// yet provided. Collected by the Welcome onboarding form.
export const REQUIRED_PROFILE_FIELDS = [
  'sex',
  'height_cm',
  'weight_kg',
  'activity_level',
] as const;

// Required fields stored on the users row (the Supabase auth mirror).
// Collected by the age gate.
export const REQUIRED_USER_FIELDS = ['date_of_birth'] as const;

export type RequiredProfileField = (typeof REQUIRED_PROFILE_FIELDS)[number];

// True when every required profile field is non-null.
export function isProfileComplete(profile: UserProfile | null): boolean {
  if (!profile) return false;
  return REQUIRED_PROFILE_FIELDS.every((field) => profile[field] != null);
}

// True when every required users-row field is non-null.
export function hasRequiredUserFields(user: User | null): boolean {
  if (!user) return false;
  return REQUIRED_USER_FIELDS.every((field) => user[field] != null);
}
